import {
  core_v1_Rule,
  coreV1ListRulesInfiniteOptions,
  CoreV1ListRulesResponse,
} from '@antimatterhq/asl-api-ts-v1';
import { useInfiniteQuery } from '@antimatterhq/ui/hooks/queries/useInfiniteQuery';
import { useWarehouseLocation } from '@/contexts/WarehouseLocationContext';
import { useWorkspace } from '@/contexts/WorkspaceContext';
import { defaultOptions } from '@/utils/query';
import { useOptimisticUpdateFromInfiniteQuery } from '@/hooks/query/useOptimisticUpdateFromInfiniteQuery';
import { useOptimisticDeleteFromInfiniteQuery } from '@/hooks/query/useOptimisticDeleteFromInfiniteQuery';

const DEFAULT_LIST_RULES_LIMIT = 500;

interface UseGetRulesInfiniteArgs {
  limit?: number;
}

export const useGetRulesInfinite = (args?: UseGetRulesInfiniteArgs) => {
  const limit = args?.limit ?? DEFAULT_LIST_RULES_LIMIT;

  const { workspace } = useWorkspace();
  const { selectedWarehouse } = useWarehouseLocation();
  const warehouse = selectedWarehouse?.id || '';

  const options = coreV1ListRulesInfiniteOptions({
    ...defaultOptions(),
    path: { workspace },
    query: { limit },
  });

  const queryKey = options.queryKey;

  const optimisticDelete = useOptimisticDeleteFromInfiniteQuery<
    core_v1_Rule,
    CoreV1ListRulesResponse
  >(queryKey, limit, (i: core_v1_Rule) => i.metadata?.name ?? '');

  const optimisticUpdate = useOptimisticUpdateFromInfiniteQuery<
    core_v1_Rule,
    CoreV1ListRulesResponse
  >(queryKey, limit, (i: core_v1_Rule) => i.metadata?.name ?? '');

  const query = useInfiniteQuery({
    ...options,
    enabled: !!workspace && !!warehouse,
    getNextPageParam: (page) => {
      return page?.metadata?.cursor;
    },
  });

  return {
    ...query,
    optimisticDelete,
    optimisticUpdate,
  };
};
